<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Edit general information</cll-dialog-title>
        <cll-dialog-subtitle>For {{ client.reference }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <div class="dialog-container-header">
            <cll-icon type="outlined" [size]="24">person</cll-icon>
            <span class="dialog-container-header-text">General information</span>
        </div>
        <div class="grid-columns-3">
            <div>
                <cll-form-field label="Title">
                    <input cllFormInput
                           [formControl]="personDetailsFormGroup.controls.title"
                           type="text">
                </cll-form-field>
            </div>
            <div>
                <cll-form-field label="Given name">
                    <input cllFormInput
                           [formControl]="personDetailsFormGroup.controls.given_name"
                           type="text">
                </cll-form-field>
            </div>
            <div>
                <cll-form-field label="Family name">
                    <input cllFormInput
                           [formControl]="personDetailsFormGroup.controls.family_name"
                           type="text">
                </cll-form-field>
            </div>
        </div>
        <div>
            <div>
                <cll-form-field label="Middle names">
                    <input cllFormInput
                           [formControl]="personDetailsFormGroup.controls.middle_names"
                           type="text">
                </cll-form-field>
            </div>
        </div>
        <div class="grid-columns-2">
            <div>
                <cll-form-field label="Preferred name">
                    <input cllFormInput
                           [formControl]="personDetailsFormGroup.controls.preferred_name"
                           type="text">
                </cll-form-field>
            </div>
            <div>
                <cll-form-field label="Pronouns">
                    <input cllFormInput
                           [formControl]="personDetailsFormGroup.controls.pronouns"
                           type="text">
                </cll-form-field>
            </div>
        </div>
        <div class="grid-columns-2">
            <div>
                <cll-form-field label="Date of birth">
                    <input cllFormInput
                           [formControl]="personDetailsFormGroup.controls.date_of_birth"
                           type="date">
                </cll-form-field>
            </div>
            <div>
                <cll-form-field label="Birth sex">
                    <select cllFormInput
                            [formControl]="personDetailsFormGroup.controls.birth_sex">
                        <option value=""></option>
                        <option value="m">Male</option>
                        <option value="f">Female</option>
                        <option value="o">Indeterminate</option>
                    </select>
                </cll-form-field>
            </div>
        </div>
        <div class="grid-columns-2">
            <div>
                <cll-form-field label="Reference">
                    <input cllFormInput
                           [formControl]="clientDetailsFormGroup.controls.reference"
                           type="text">
                </cll-form-field>
            </div>
            <div>
                <cll-form-field label="NHS number">
                    <input cllFormInput
                           [formControl]="clientDetailsFormGroup.controls.nhs_number"
                           type="text">
                </cll-form-field>
            </div>
        </div>
    </div>
    <span class="dialog-divider"></span>
    @if (this.updateClientRequest.error(); as error) {
        <app-error-panel [error]="error" />
    }
    <cll-dialog-footer>
        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="clientDetailsFormGroup.invalid || personDetailsFormGroup.invalid || updateClientRequest.loading()"
                (click)="update()">
            Save
        </button>

    </cll-dialog-footer>
</cll-dialog-layout>
